"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isRiderDialCustomerRequest = void 0;
var superstruct_1 = require("superstruct");
var isStruct_1 = require("../../utils/isStruct");
var RiderDialCustomerRequestStruct = (0, superstruct_1.type)({
    taskId: (0, superstruct_1.string)(),
});
function isRiderDialCustomerRequest(obj) {
    return (0, isStruct_1.isStruct)(obj, RiderDialCustomerRequestStruct, "RiderDialCustomerRequest");
}
exports.isRiderDialCustomerRequest = isRiderDialCustomerRequest;
